export function encodePassphrase(passphrase: string) {
  return encodeURIComponent(passphrase);
}

export function decodePassphrase(base64String: string) {
  return decodeURIComponent(base64String);
}

export function generateCallId(): string {
  // Human-friendly, high-entropy call ID for sharing aloud.
  const words = [generateReadableWord(), generateReadableWord(), generateReadableWord()];
  const digits = randomInt(10000).toString().padStart(4, '0');
  return `${words.join('-')}-${digits}`;
}

// Alias for backward compatibility
export const generateRoomId = generateCallId;

export function randomString(length: number): string {
  let result = '';
  const characters = 'abcdefghijklmnopqrstuvwxyz0123456789';
  const charactersLength = characters.length;
  for (let i = 0; i < length; i++) {
    result += characters.charAt(randomInt(charactersLength));
  }
  return result;
}

const READABLE_SYLLABLES = [
  'ba', 'be', 'bi', 'bo', 'bu',
  'da', 'de', 'di', 'do', 'du',
  'fa', 'fe', 'fi', 'fo', 'fu',
  'ga', 'ge', 'gi', 'go', 'gu',
  'ha', 'he', 'hi', 'ho', 'hu',
  'ja', 'je', 'ji', 'jo', 'ju',
  'ka', 'ke', 'ki', 'ko', 'ku',
  'la', 'le', 'li', 'lo', 'lu',
  'ma', 'me', 'mi', 'mo', 'mu',
  'na', 'ne', 'ni', 'no', 'nu',
  'pa', 'pe', 'pi', 'po', 'pu',
  'ra', 're', 'ri', 'ro', 'ru',
  'sa', 'se', 'si', 'so', 'su',
];

function generateReadableWord(): string {
  // Two syllables -> 4096 combinations per word.
  const first = READABLE_SYLLABLES[randomInt(READABLE_SYLLABLES.length)];
  const second = READABLE_SYLLABLES[randomInt(READABLE_SYLLABLES.length)];
  return `${first}${second}`;
}

function randomInt(max: number): number {
  if (max <= 0) return 0;
  const cryptoObj = typeof globalThis !== 'undefined'
    ? (globalThis as { crypto?: Crypto }).crypto
    : undefined;

  if (!cryptoObj || typeof cryptoObj.getRandomValues !== 'function') {
    return Math.floor(Math.random() * max);
  }

  const maxUint32 = 0xffffffff;
  const limit = maxUint32 - (maxUint32 % max);
  const buffer = new Uint32Array(1);
  let rand = 0;
  do {
    cryptoObj.getRandomValues(buffer);
    rand = buffer[0];
  } while (rand >= limit);

  return rand % max;
}

export function isLowPowerDevice() {
  return navigator.hardwareConcurrency < 6;
}
